<div class="selection-container">
    <span>{{ 'aumico_notes_super_table_reconcile_dialog_description' | i18next }}</span>
    <div class="selection-item">
        <mapping-items-selection
            [mappingItemsSelectionTree]="modifiedMappingItemsSelectionTree"
            [existingSelectionItemsNodes]="
                existingReconcileSelectionItemNodes ? existingReconcileSelectionItemNodes : []
            "
            [mulitpleSelection]="true"
            [sameNodeTypeSelection]="false"
            (onSelectedItemsChange)="onSelectedItemChange($event)"
        ></mapping-items-selection>
    </div>
</div>
